<div class="admin-shell">
  @if (sidebarOpen()) {
    <button
      type="button"
      class="sidebar-backdrop"
      (click)="closeSidebar()"
      [attr.aria-label]="'common.close' | t"
    ></button>
  }

  <aside class="sidebar" [class.open]="sidebarOpen()">
    <div class="sidebar-head">
      <div class="brand">
        <img class="brand-mark" [src]="logoUrl" [alt]="appName" />
        <div class="brand-copy">
          <strong>{{ tenantLabel() }}</strong>
          <small>{{ 'admin.panel' | t }}</small>
        </div>
      </div>

      @if (showBusinessSwitch()) {
        <div class="business-switch">
          <select
            id="admin-business"
            [ngModel]="businessKey()"
            (ngModelChange)="onBusinessKeyChange($event)"
            [attr.aria-label]="'admin.business' | t"
          >
            @for (biz of businesses(); track biz.id) {
              <option [value]="biz.key">{{ biz.name }}</option>
            }
          </select>
        </div>
      }
    </div>

    <nav class="admin-nav" [attr.aria-label]="'admin.panel' | t">
      @for (item of nav(); track item.path) {
        <a
          [routerLink]="item.path"
          routerLinkActive="active"
          [routerLinkActiveOptions]="{ exact: item.exact }"
        >
          <span class="material-symbols-outlined nav-icon" aria-hidden="true">
            {{ navIcon(item.path) }}
          </span>
          <span class="nav-label">{{ item.labelKey | t }}</span>
          @if (item.path === '/admin/chat' && unreadCount() > 0) {
            <span class="nav-badge">{{ unreadCount() }}</span>
          }
        </a>
      }
    </nav>
  </aside>

  <div class="main-column">
    @if (auth.isImpersonating()) {
      <div class="impersonation-banner">
        <span>
          {{ 'admin.impersonating' | t }}
          <strong>{{ user()?.name }}</strong>
          ({{ roleKey(user()!.role) | t }})
        </span>
        <button type="button" class="ct-btn ct-btn-sm ct-btn-navy" (click)="exitImpersonation()">
          {{ 'admin.exitImpersonation' | t }}
        </button>
      </div>
    }

    <header class="topbar">
      <div class="topbar-start">
        <button
          type="button"
          class="icon-btn menu-btn"
          (click)="toggleSidebar()"
          [attr.aria-label]="'admin.panel' | t"
        >
          <span class="material-symbols-outlined" aria-hidden="true">menu</span>
        </button>
        <h1 class="page-title">{{ pageTitle() }}</h1>
      </div>

      <div class="topbar-end">
        <div class="topbar-session">
          <div class="topbar-icons">
            <app-language-switcher />
            @if (showChat()) {
              <app-admin-chat-notifier />
            }
            <a
              class="icon-btn"
              routerLink="/"
              [attr.aria-label]="'admin.viewStorefront' | t"
              [title]="'admin.viewStorefront' | t"
            >
              <span class="material-symbols-outlined" aria-hidden="true">storefront</span>
            </a>
            <button
              type="button"
              class="icon-btn"
              (click)="logout()"
              [attr.aria-label]="'admin.logout' | t"
              [title]="'admin.logout' | t"
            >
              <span class="material-symbols-outlined" aria-hidden="true">logout</span>
            </button>
          </div>

          @if (user(); as current) {
            <div class="user-block">
              <div class="user-copy">
                <p class="user-name">{{ current.name }}</p>
                <p class="user-role">{{ roleKey(current.role) | t }}</p>
              </div>
              <span class="user-avatar" aria-hidden="true">
                {{ current.name.charAt(0).toUpperCase() }}
              </span>
            </div>
          }
        </div>
      </div>
    </header>

    <main class="main">
      <div class="page">
        @if (sessionReady()) {
          @for (n of [outletEpoch()]; track n) {
            <router-outlet />
          }
        } @else {
          <p class="page-loading">{{ 'common.loading' | t }}</p>
        }
      </div>
    </main>
  </div>

  @if (showAiAssistant()) {
    <app-ai-marketing-assistant-widget />
  }
</div>
